module.exports = __webpack_public_path__ + "static/img/award5_a.5334dce.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award5_a.png
// module id = 1/zC
// module chunks = 7